var _defs, _rect, _rect2, _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.065,
    height: 77.674,
    viewBox: "0 0 92.065 77.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-5,.cls-7{fill:none}.cls-5{stroke-width:4px;stroke:#e24c48;stroke-linecap:round}.cls-6{stroke:none}\r\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "paiment-failed",
    transform: "translate(-134 -124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_846",
    "data-name": "Group 846",
    transform: "translate(8 5)",
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    transform: "translate(126 119)",
    style: {
      strokeWidth: 4,
      stroke: "#0c0c0c",
      fill: "none"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 92.065,
    height: 60,
    rx: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2,
    y: 2,
    width: 88.065,
    height: 56,
    rx: 6
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    width: 92.065,
    height: 14,
    rx: 1,
    transform: "translate(126 130)",
    style: {
      fill: "#0c0c0c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_848",
    "data-name": "Group 848",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    transform: "translate(160 163)",
    style: {
      stroke: "#e24c48",
      fill: "#f9fafa",
      strokeWidth: 4
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 20.337,
    cy: 20.337,
    r: 20.337
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 20.337,
    cy: 20.337,
    r: 18.337
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "rotate(45 -1360.323 1144.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    className: "cls-5",
    transform: "translate(-958.5 -624.659)",
    d: "M0 0h15.682"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4",
    "data-name": "Line 4",
    className: "cls-5",
    transform: "rotate(90 -159.08 -791.58)",
    d: "M0 0h15.682"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailed);
export default __webpack_public_path__ + "static/media/payment-failed.8074b306.svg";
export { ForwardRef as ReactComponent };